//import { WebPubSubServiceClient } from '@azure/web-pubsub';  這是server端的
//webwocket  https://learn.microsoft.com/zh-tw/azure/azure-web-pubsub/howto-websocket-connect?tabs=browser
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import axios from 'axios';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { webSpeechClass } from './jkWebSpeech';
import { AzureEnvironment, CR } from './jkInterface';

const azureEnv:AzureEnvironment = {
  tts_key: '',
  tts_url: '',
  translate_key: '',
  AZURE_OPENAI_KEY: '',
  AZURE_OPENAI_ENDPOINT: '',
  region: '',

}

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private http = inject(HttpClient);

  private url =
    'https://api.cognitive.microsofttranslator.com/translate?api-version=3.0'; // &to=zh-Hant';
  private doc_url = 'https://jackie57lo.cognitiveservices.azure.com/';
  azureEnv:AzureEnvironment = {
    tts_key: '',
    tts_url: '',
    translate_key: '',
    AZURE_OPENAI_KEY: '',
    AZURE_OPENAI_ENDPOINT: '',
    region: '',
  }
  init(azure:AzureEnvironment){
    this.azureEnv = azure;
  }
  //curl -X POST "https://api.cognitive.microsofttranslator.com/translate?api-version=3.0&from=en&to=zh-Hans" -H "Ocp-Apim-Subscription-Key: <client-secret>" -H
  //"Content-Type: application/json; charset=UTF-8" -d "[{'Text':'Hello, what is your name?'}]"

  translate(text: string, to: string, from: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8',
        'Ocp-Apim-Subscription-Key': this.azureEnv.translate_key || '',
        'Ocp-Apim-Subscription-Region': this.azureEnv.region || '',
      }),
    };

    const body = [
      {
        text: text,
      },
    ];
    let u = this.url + '&to=' + to;
    return this.http.post(u, body, httpOptions);
  }
  translateText(){
    let options = {
    method: 'POST',
    baseURL: this.url,
    url: 'translate',
    params: {
    'api-version': '3.0',
    'to': ['de', 'it']
    },
    headers: {
    'Ocp-Apim-Subscription-Key': this.azureEnv.translate_key || '',
    'Ocp-Apim-Subscription-Region': this.azureEnv.region,
    'Content-type': 'application/json',
    'X-ClientTraceId': uuidv4().toString()
    },
    data: [{
    'text': 'Hello World!'
    }]
    };

    axios(options).then((response: any) => {
    console.log(JSON.stringify(response.data, null, 4));
    }).catch(error => {
    console.error('Error:', error);
    });
   };

}


@Injectable({
  providedIn: 'root',
})
export class AzureTtsService {
  private http = inject(HttpClient);

  isAzureSpeech: boolean = true;
  webSpeech: webSpeechClass;
  voiceIndex: number = 21;
  constructor() {
    // Don't inject ChangeDetectorRef here to avoid circular dependency
    this.webSpeech = new webSpeechClass();
    this.voiceIndex = this.webSpeech.language2VoiceIndex('zh-TW'); // prompt("Please enter a string:");
  }

  // https://speech.microsoft.com/portal/b5bd780aceb5408b8b05a85d76b90d1e/voicegallery
  // 曉臻 zh-TW-HsiaoChenNeural,雲哲 zh-TW-YunJheNeural,曉雨 zh-TW-HsiaoYuNeural
  //init(azure:AzureEnvironment){
  //  this.azureEnv = azure;
  //}
  textToSpeech(
    azureEnv:AzureEnvironment,
    text: string,
    voiceName: string = 'zh-TW-HsiaoChenNeural'
  ): Observable<ArrayBuffer> {
    if(!azureEnv.tts_key || !azureEnv.tts_url){
      alert('azure tts key or url is empty');
      return new Observable<ArrayBuffer>();
    };
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': azureEnv.tts_key || '',
      'Content-Type': 'application/ssml+xml',
      'X-Microsoft-OutputFormat': 'audio-16khz-128kbitrate-mono-mp3',
    });

    const body = `
      <speak version='1.0' xml:lang='en-US'>
        <voice xml:lang='zh-TW' xml:gender='Female' name='${voiceName}'>
          ${text}
        </voice>
      </speak>`;

    return this.http.post(azureEnv.tts_url || '', body, {
      headers,
      responseType: 'arraybuffer',
    });
  }
  speakText(azureEnv:AzureEnvironment,msg: string, voiceName: string = 'zh-TW-HsiaoChenNeural') {
    if (this.isAzureSpeech) {
      this.textToSpeech(azureEnv,msg, voiceName).subscribe({
        next: (audio) => {
          // 處理正常的值
          const audioBlob = new Blob([audio], { type: 'audio/mp3' });
          const audioUrl = URL.createObjectURL(audioBlob);
          const audioElement = new Audio(audioUrl);
          audioElement.play();
        },
        error: (error) => {
          // 處理錯誤
          alert(' azure tts錯誤:' + error.message);
        },
        complete: () => {
          // 完成時執行（可選）
        },
      });
    } else {
      this.webSpeech.speakText(msg, this.voiceIndex, 1);
    }
  }
  async showVoices() {
    //let n = this.webSpeech.language2VoiceIndex('zh-TW'); // prompt("Please enter a string:");
    let msg = '第' + this.voiceIndex + '語言' + CR + this.webSpeech.getSettings(); //this.webSpeech.speakText('第N語言'+n, n, 1);
    alert(msg);
  }
}
